/** Condizioni predefinite che la vedetta può segnalare al DOS. */
export const TRIGGER_PREDEFINITI: string[] = [
  'Aumento improvviso velocità',
  'Cambio condizioni meteo',
  'Cambio direzione vento',
  'Fiamma torching',
  'Fumo aumenta rapidamente',
  'Fuoco supera linea perimetro',
  'Perdita copertura radio',
  'Spotting oltre perimetro',
];
